<div class="relative flex flex-col rounded-2xl overflow-hidden">
  <button type="button" (click)="onClose()"
    class="absolute top-4 right-4 z-10 flex items-center justify-center w-8 h-8 rounded-full text-text_black hover:bg-black/5 cursor-pointer transition-colors">
    <i class="pi pi-times"></i>
  </button>

  <!-- Warm the browser cache for every step's video as soon as the tour opens,
       so switching steps plays instantly instead of downloading on demand. -->
  @for (src of videoSources; track src) {
  <video class="hidden" muted playsinline preload="auto" [src]="src"></video>
  }

  <div class="tour-visual">
    @switch (step()) {
      @case (0) {
      <div class="flex items-center justify-center w-full h-full bg-gray_light">
        <img src="images/Logo.svg" alt="Deal Huddle" class="h-16" />
      </div>
      }
      @case (1) {
      <video class="w-full h-full object-cover" autoplay loop muted playsinline
        [src]="videoSources[0]"></video>
      }
      @case (2) {
      <video class="w-full h-full object-cover" autoplay loop muted playsinline
        [src]="videoSources[1]"></video>
      }
      @case (3) {
      <video class="w-full h-full object-cover" autoplay loop muted playsinline
        [src]="videoSources[2]"></video>
      }
    }
  </div>

  <div class="p-6 bg-white sm:p-8">
    <p class="text-text_gray mb-2">Step {{ step() + 1 }} of {{ totalSteps }}</p>
    <h2 class="text-xl font-medium mb-3 sm:text-2xl">{{ steps[step()].title }}</h2>
    <p class="text-text_black leading-relaxed">{{ steps[step()].description }}</p>

    <div class="mt-8 flex flex-col gap-5 sm:flex-row sm:items-center sm:justify-between sm:gap-0">
      <div class="flex items-center justify-center gap-1.5 sm:justify-start">
        @for (s of [].constructor(totalSteps); let i = $index; track i) {
        <span class="h-1.5 rounded-full transition-all" [class]="i === step() ? 'w-6 bg-active' : 'w-1.5 bg-app-secondary'"></span>
        }
      </div>

      <div class="flex items-center justify-between gap-3 sm:justify-end">
        @if (step() === 0) {
        <p-button label="Skip for now" [text]="true" severity="secondary" styleClass="text-text_black" (onClick)="skip()" />
        <p-button label="Take a tour" (onClick)="next()" />
        } @else {
        <p-button label="Back" [text]="true" severity="secondary" styleClass="text-text_black" (onClick)="back()" />
        @if (step() < totalSteps - 1) {
        <p-button label="Next" (onClick)="next()" />
        } @else {
        <p-button label="Go to my deals" (onClick)="goToDeals()" />
        }
        }
      </div>
    </div>
  </div>
</div>
